import {Button, Image, OverlayTrigger, Popover} from 'react-bootstrap';
import classNames from './top-nav-bar.module.css';
import PTWLOGO from 'images/PTWlogo.png';
import profileImgPlaceHolder from 'images/svg/default-user.svg';
import {useContext} from 'react';
import {AuthContext} from 'contexts/auth.context';
import downArrow from 'images/svg/caret-down-solid.svg';
import {useTranslation} from 'react-i18next';

const NavBar = () => {
  const {t} = useTranslation();
  const authProvider = useContext(AuthContext);
  const userDetails = authProvider.userDetails;
  // const profileDetails = authProvider.profileSettings;

  const popoverTopnav = (
    <Popover
      className={
        'leaveType-popover-edit-delete' +
        classNames['custom-popover'] +
        ' ' +
        classNames['popover-navtop']
      }
      id="custom-popover-top"
    >
      <Popover.Content>
        <>
          <div className={classNames['user-name-text-view']}>
            {`${userDetails?.firstName || ''} ${
              userDetails?.middleName || ''
            } ${userDetails?.lastName || ''}`}
          </div>
          <div
            className={' align-items-center p-0 ' + classNames['hover-elem']}
          >
            <Button
              variant="light"
              className={
                'popover-edit-btn ' +
                classNames['edit-btn'] +
                ' ' +
                classNames['sign-out-btn']
              }
              onClick={authProvider.handleLogout}
            >
              {t('Search_Job_Sign Out')}
            </Button>
          </div>
        </>
      </Popover.Content>
    </Popover>
  );

  return (
    <>
      <div id="nav-bar" className={classNames['top-nav-bar-container']}>
        <div className={classNames['top-nav-bar-logo-div']}>
          <img className={classNames['top-nav-bar-image-logo']} src={PTWLOGO} />
        </div>
        <div className={classNames['top-nav-bar-logout-div']}>
          <div className={classNames['profile-image-box']}>
            <label className="d-flex mr-2">
              <Image
                src={
                  userDetails?.profile_pic
                    ? userDetails?.profile_pic
                    : profileImgPlaceHolder
                }
                className={
                  'Emp-profile' + ' ' + classNames['top-nav-bar-profile']
                }
              />
            </label>
            <span
              className={
                'ml-3 mr-2 hide-in-device' + ' ' + classNames['user-name-text']
              }
              title={`${userDetails?.firstName || ''} ${
                userDetails?.middleName || ''
              } ${userDetails?.lastName || ''}`}
            >
              {`${userDetails?.firstName || ''} ${
                userDetails?.middleName || ''
              } ${userDetails?.lastName || ''}`}
            </span>
            <OverlayTrigger
              trigger="click"
              rootClose={true}
              placement="bottom"
              overlay={popoverTopnav}
            >
              <img
                src={downArrow}
                className={classNames['top-nav-bar-down-arrow']}
              />
            </OverlayTrigger>
          </div>
        </div>
      </div>
    </>
  );
};

export default NavBar;
